import React, { Component } from 'react';

interface IProps {
  count: number | string;
  final?: string;
  upper?: boolean;
  lower?: boolean;
  style?: any;
  title?: string;
  children: React.ReactNode;
  after?: React.ReactNode;
}

class Truncate extends Component<IProps, any> {
  constructor(props: IProps) {
    super(props);
    this.truncate = this.truncate.bind(this);
  }

  truncate = (value: any) => {
    const { count, final, upper, lower } = this.props;

    if (value && value.length >= count) {
      value = value.slice(0, count);
      if (final) {
        value = value + final;
      }
      if (upper) {
        value = value.toUpperCase();
      } else if (lower) {
        value = value.toLowerCase();
      }
    }
    return value;
  };

  render() {
    return (
      <div style={this.props.style} title={this.props.title}>
        {this.truncate(this.props.children)}
        {this.props.after}
      </div>
    );
  }
}
export default Truncate;
